import React, { ReactNode } from 'react';
import cs from 'classnames';
import styles from './Error.module.scss';

const Error = ({ children, className }: { children: ReactNode; className?: string }) => (
  <div className={cs(styles.error, className)}>{children}</div>
);

export { Error };
